<template>
  <td data-int="cart-cell-chapter">
    {{ item.chapterName }}
  </td>
</template>

<script>
export default {
  name: 'CartCellChapter',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>

</style>
